/* ============================================================
   velmontier müşteri revizyonları — kart eklentileri (JS enjeksiyon)
   Kart Liquid'ine dokunmaz; on-load DOM'a rozet/yıldız/bant/sepete-ekle ekler.
   ============================================================ */
(function () {
  'use strict';

  var STAR_COUNT = 5; // #22 minimal yıldız (yorum uygulaması yoksa statik)

  var BAG_SVG =
    '<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M4.13 18.33h13.74a.55.55 0 0 0 .54-.46l1.65-9.9a.55.55 0 0 0-.54-.64H2.48a.55.55 0 0 0-.54.64l1.65 9.9c.04.27.27.46.54.46Z" stroke="currentColor" stroke-width="1.3"/>' +
    '<path d="M6.42 7.33V5.5A1.83 1.83 0 0 1 8.25 3.67h5.5A1.83 1.83 0 0 1 15.58 5.5v1.83" stroke="currentColor" stroke-width="1.3"/></svg>';

  function mediaOf(card) {
    return card.querySelector('.card__media, .card-horizontal__image, .media--hover-effect, .media');
  }
  function handleOf(card) {
    if (card.dataset.product) return card.dataset.product;
    var a = card.querySelector('a[href*="/products/"]');
    if (a) { var m = a.getAttribute('href').match(/\/products\/([a-z0-9\-]+)/i); if (m) return m[1]; }
    return null;
  }

  function buildStars() {
    var s = '';
    for (var i = 0; i < STAR_COUNT; i++) s += '★';
    var el = document.createElement('div');
    el.className = 'rv-stars';
    el.setAttribute('aria-hidden', 'true');
    el.textContent = s;
    return el;
  }
  function buildBadges() {
    var wrap = document.createElement('div');
    wrap.className = 'rv-badges';
    var guaranteeText = (window.themeTranslations && window.themeTranslations.lifetime_guarantee) || 'ÖMÜR BOYU GARANTİ';
    var badges = ['14 K GOLD', guaranteeText];
    badges.forEach(function (t) {
      var b = document.createElement('span');
      var isGuarantee = (t === guaranteeText) || (t.indexOf('GARANTİ') >= 0) || (t.indexOf('GUARANTEE') >= 0);
      b.className = 'rv-badge' + (isGuarantee ? ' rv-badge--light' : '');
      b.textContent = t;
      wrap.appendChild(b);
    });
    return wrap;
  }
  function buildRibbon(text) {
    var r = document.createElement('div');
    r.className = 'rv-sale-ribbon';
    var track = document.createElement('div');
    track.className = 'rv-sale-ribbon__track';
    var unit = '';
    for (var i = 0; i < 8; i++) unit += '<span>' + text + '</span>';
    track.innerHTML = unit + unit; // %50 kayma için iki kopya
    r.appendChild(track);
    return r;
  }
  function buildAddButton(handle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rv-add';
    var labelText = (window.themeTranslations && window.themeTranslations.add_to_cart) || 'Sepete ekle';
    b.setAttribute('aria-label', labelText);
    b.innerHTML = BAG_SVG;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      addToCart(handle, b);
    });
    return b;
  }

  function addToCart(handle, btn) {
    if (!handle) { window.location = '/products'; return; }
    btn.classList.add('is-loading');
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variant = null, i;
        for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { variant = p.variants[i]; break; } }
        if (!variant) variant = p.variants[0];
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: variant.id, quantity: 1 }] };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
        }
        return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          var drawer2 = document.querySelector('cart-drawer');
          if (drawer2 && typeof drawer2.renderContents === 'function') {
            drawer2.classList.remove('is-empty');
            drawer2.renderContents(res);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        });
      })
      .catch(function () { window.location = '/products/' + handle; })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  function decorate(card) {
    if (card.dataset.rvDone) return;
    card.dataset.rvDone = '1';
    var media = mediaOf(card);
    if (!media) return;
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';

    // Tek sarmalayıcı — temanın .media>* fill kuralından korunmak için
    var ov = document.createElement('div');
    ov.className = 'rv-overlay';

    ov.appendChild(buildBadges());            // #17
    // #22 yıldızlar müşteri isteğiyle KALDIRILDI (ürün görseli üstünde istemiyor)

    // #1 sale bandı — kartta indirim varsa
    var compareEl = card.querySelector('.price__compare .price-item--regular, s.price-item--regular');
    if (card.querySelector('.price--on-sale') && compareEl && compareEl.textContent.trim()) {
      var indirimText = (window.themeTranslations && window.themeTranslations.indirim) || 'İNDİRİM';
      var saleText = (window.themeTranslations && window.themeTranslations.sale) || 'SALE';
      var ribbonText = indirimText === saleText ? indirimText : (indirimText + ' • ' + saleText);
      ov.appendChild(buildRibbon(ribbonText));
    }

    // #16 MV sepete-ekle butonu
    ov.appendChild(buildAddButton(handleOf(card)));

    media.appendChild(ov);
  }

  // #21 PDP stok çubuğu — envanter düşükse "ONLY X LEFT" gradient bar
  function stockBar() {
    var inv = document.querySelector('.product__inventory');
    if (!inv || inv.dataset.rvBar) return;
    var m = (inv.textContent || '').match(/(\d+)\s*in stock/i);
    if (!m) return;
    var n = parseInt(m[1], 10);
    if (!n || n > 30) return; // sadece düşük stokta göster
    inv.dataset.rvBar = '1';
    var pct = Math.max(8, Math.min(100, Math.round((n / 30) * 100)));
    var bar = document.createElement('div');
    bar.className = 'rv-stockbar';
    var stockLabelHtml = ((window.themeTranslations && window.themeTranslations.stock_left) || 'Stokta son <strong>[count]</strong> adet')
      .replace('[count]', n);
    bar.innerHTML =
      '<div class="rv-stockbar__top"><span class="rv-stockbar__dot"></span>' +
      '<span class="rv-stockbar__label">' + stockLabelHtml + '</span></div>' +
      '<div class="rv-stockbar__track"><div class="rv-stockbar__fill" style="width:' + pct + '%"></div></div>';
    inv.parentNode.insertBefore(bar, inv.nextSibling);
  }

  // #9/#19 — compare-at (eski) fiyatı dolu olan .price'a price--on-sale ekle
  // (tema markup'ı sınıfı koymuyorsa indirimli fiyat + #A35C5D burada devreye girer)
  function priceSale() {
    document.querySelectorAll('.price').forEach(function (p) {
      if (p.classList.contains('price--on-sale')) return;
      var cmp = p.querySelector('.price__compare s, .price__compare .price-item--regular');
      if (cmp && /\d/.test(cmp.textContent)) p.classList.add('price--on-sale');
    });
  }

  // PDP'de tekrar eden "Next day delivery available" gibi metinleri tekille (statik artık)
  function dedupeText() {
    var seen = {};
    document.querySelectorAll('.product__info-main_content [class*="delivery"], .product__delivery, .product__pickup, .product__info-main_content p, .product__info-main_content div').forEach(function (el) {
      if (el.children.length) return;
      var t = (el.textContent || '').trim();
      if (!t || t.length > 60) return;
      if (/delivery available|kargo|teslimat/i.test(t)) {
        if (seen[t]) { el.style.display = 'none'; } else { seen[t] = 1; }
      }
    });
  }

  // #13 PDP görsel zoom — görsele tıklayınca büyük görseli overlay'de aç
  function productZoom() {
    var imgs = document.querySelectorAll('.product__media-item .product__media img, .product__media-list .product__media img');
    if (!imgs.length) return;
    var ov = document.querySelector('.rv-zoom');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'rv-zoom';
      var closeText = (window.themeTranslations && window.themeTranslations.close) || 'Kapat';
      ov.innerHTML = '<button class="rv-zoom__close" aria-label="' + closeText + '" type="button">&times;</button><img alt="">';
      document.body.appendChild(ov);
      ov.addEventListener('click', function () { ov.classList.remove('is-open'); });
    }
    imgs.forEach(function (im) {
      if (im.dataset.rvZoom) return;
      im.dataset.rvZoom = '1';
      im.style.cursor = 'zoom-in';
      im.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var src = im.currentSrc || im.src;
        var big = src.replace(/([?&]width=)\d+/, '$11600');
        ov.querySelector('img').src = big;
        ov.classList.add('is-open');
      });
    });
  }

  // Koleksiyon/kategori facet filtresi — Search & Discovery app yoksa URL paramlarına göre
  // kartları istemci tarafında süz (küçük katalog için). facets.js zaten filtreli URL'e gider.
  function collectionFilter() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;
    var params = new URLSearchParams(location.search);
    var types = params.getAll('filter.p.product_type').map(function (s) { return s.toLowerCase(); });
    var avails = params.getAll('filter.v.availability');
    var tags = params.getAll('filter.p.tag').map(function (s) { return s.toLowerCase(); });
    var vendors = params.getAll('filter.p.vendor').map(function (s) { return s.toLowerCase(); });
    var gte = parseFloat(params.get('filter.v.price.gte'));
    var lte = parseFloat(params.get('filter.v.price.lte'));
    var optionVals = [];
    params.forEach(function (val, key) { if (key.indexOf('filter.v.option.') === 0 || key.indexOf('filter.p.m.') === 0) optionVals.push(val.toLowerCase()); });
    var hasFilter = types.length || avails.length || tags.length || vendors.length || optionVals.length || !isNaN(gte) || !isNaN(lte);
    var items = grid.querySelectorAll('.product-card-item');
    var shown = 0;
    items.forEach(function (li) {
      var ok = true;
      if (types.length && types.indexOf((li.getAttribute('data-rv-type') || '')) === -1) ok = false;
      if (ok && avails.length && avails.indexOf(li.getAttribute('data-rv-available')) === -1) ok = false;
      if (ok && vendors.length && vendors.indexOf((li.getAttribute('data-rv-vendor') || '')) === -1) ok = false;
      if (ok && tags.length) {
        var ct = (li.getAttribute('data-rv-tags') || '').split('|');
        if (!tags.some(function (t) { return ct.indexOf(t) >= 0; })) ok = false;
      }
      if (ok && optionVals.length) {
        var co = (li.getAttribute('data-rv-options') || '').split('|');
        if (!optionVals.every(function (v) { return co.indexOf(v) >= 0; })) ok = false;
      }
      if (ok && (!isNaN(gte) || !isNaN(lte))) {
        var price = parseFloat(li.getAttribute('data-rv-price') || '0') / 100;
        if (!isNaN(gte) && price < gte) ok = false;
        if (!isNaN(lte) && price > lte) ok = false;
      }
      li.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    if (hasFilter) {
      var pc = document.querySelector('#ProductCount');
      if (pc) pc.textContent = '(' + shown + ')';
      var nores = grid.querySelector('.rv-nores');
      if (shown === 0 && !nores) {
        nores = document.createElement('li');
        nores.className = 'rv-nores';
        nores.style.cssText = 'grid-column:1/-1;text-align:center;padding:5rem 2rem;color:#8a857e;font-size:1.3rem;';
        var noResultsText = (window.themeTranslations && window.themeTranslations.no_results) || 'Bu filtreyle eşleşen ürün bulunamadı.';
        nores.textContent = noResultsText;
        grid.appendChild(nores);
      } else if (shown > 0 && nores) { nores.remove(); }
    }
  }

  function updateVariantLabels() {
    document.querySelectorAll('variant-radios fieldset, variant-selects fieldset').forEach(function (fs) {
      var span = fs.querySelector('.selected-value-span');
      var checkedInput = fs.querySelector('input:checked');
      if (span && checkedInput) {
        span.textContent = checkedInput.value;
      }
    });
  }

  function interceptProductForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      if (form.dataset.rvFormAjax) return;
      form.dataset.rvFormAjax = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"], [name="add"]');
        if (btn) btn.classList.add('loading');
        
        var drawer = document.querySelector('cart-drawer');
        var formData = new FormData(form);
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          formData.append('sections_url', window.location.pathname);
        }
        
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function(res) {
           if (drawer && typeof drawer.renderContents === 'function') {
             drawer.classList.remove('is-empty');
             drawer.renderContents(res);
           } else {
             window.location = (window.routes && window.routes.cart_url) || '/cart';
           }
        })
        .catch(function() {
           window.location = (window.routes && window.routes.cart_url) || '/cart';
        })
        .finally(function() {
           if (btn) btn.classList.remove('loading');
        });
      });
    });
  }

  function updateReturnToInputs() {
    var currentPath = window.location.pathname + window.location.search;
    document.querySelectorAll('localization-form form input[name="return_to"]').forEach(function(input) {
      input.value = currentPath;
    });
  }

  function run() {
    updateReturnToInputs();
    var cards = document.querySelectorAll('.card-wrapper[data-product], .collection-product-card, .card-horizontal-wrapper[data-product]');
    priceSale();                 // önce sale sınıfını ekle ki #1 ribbon koşulu çalışsın
    cards.forEach(decorate);
    stockBar();
    dedupeText();
    productZoom();
    collectionFilter();
    updateVariantLabels();
    interceptProductForm();

    document.querySelectorAll('variant-radios, variant-selects').forEach(function (el) {
      if (el.dataset.rvObsLabel) return;
      el.dataset.rvObsLabel = '1';
      el.addEventListener('change', updateVariantLabels);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);

  // facets.js AJAX ile ürün grid'ini yeniden render ederse, istemci-filtresini tekrar uygula
  window.addEventListener('popstate', function () { setTimeout(collectionFilter, 200); });
  function bindGridObserver() {
    var gridC = document.querySelector('#ProductGridContainer');
    if (!gridC || gridC.dataset.rvObs) return;
    gridC.dataset.rvObs = '1';
    new MutationObserver(function (muts) {
      var reRender = muts.some(function (m) {
        return [].some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && ((n.matches && n.matches('.product-card-item')) || (n.querySelector && n.querySelector('.product-card-item')));
        });
      });
      if (reRender) setTimeout(collectionFilter, 60);
    }).observe(gridC, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindGridObserver);
  else bindGridObserver();
  document.addEventListener('shopify:section:load', bindGridObserver);

  // Helper to redirect to language-prefixed URL paths (e.g. /tr/products/... or /products/...)
  function redirectToLanguage(targetLocale) {
    var currentLocale = (window.Shopify && window.Shopify.locale) || 'en';
    if (targetLocale === currentLocale) return;

    var pathname = window.location.pathname;
    var search = window.location.search;
    var hash = window.location.hash;
    var newPathname = pathname;
    var pathParts = pathname.split('/');
    // If the URL has a 2-letter language code prefix (excluding special routes like /js), remove it
    if (pathParts.length > 1 && pathParts[1].length === 2 && pathParts[1] !== 'js') {
      pathParts.splice(1, 1);
      newPathname = pathParts.join('/');
    }
    // Add new language prefix if it's not the default (primary) locale of the shop
    var primaryLocale = window.primaryLocale || 'tr';
    if (targetLocale !== primaryLocale) {
      newPathname = '/' + targetLocale + (newPathname === '/' ? '' : newPathname);
    }
    window.location.href = window.location.origin + newPathname + search + hash;
  }

  // Native localization-form submissions will proceed automatically, using the updated return_to input values.

  // Listen for manual language switcher selections
  function listenForManualLanguageChange() {
    document.querySelectorAll('localization-form form').forEach(function(form) {
      form.addEventListener('submit', function() {
        var input = form.querySelector('input[name="locale_code"]');
        if (input && input.value) {
          localStorage.setItem('velmontier_user_language', input.value);
        }
      });
      form.querySelectorAll('select, [data-value]').forEach(function(el) {
        el.addEventListener('change', function() {
          if (el.value) localStorage.setItem('velmontier_user_language', el.value);
        });
        el.addEventListener('click', function() {
          var val = el.getAttribute('data-value') || el.value;
          if (val) localStorage.setItem('velmontier_user_language', val);
        });
      });
    });
  }

  // Automatic Language Detection and Switcher based on Browser Language and Country
  function autoDetectLanguage() {
    // Listen for manual changes first
    listenForManualLanguageChange();

    var userLanguage = localStorage.getItem('velmontier_user_language');
    var currentLocale = (window.Shopify && window.Shopify.locale) || 'en';

    if (userLanguage) {
      // If the current locale doesn't match their chosen language, redirect them
      if (userLanguage !== currentLocale) {
        redirectToLanguage(userLanguage);
      }
      return;
    }

    // 1. Check if we already did auto-detection for this user
    if (localStorage.getItem('velmontier_lang_detected')) return;
    localStorage.setItem('velmontier_lang_detected', '1');

    // 2. Get available languages in the store
    var availableLangs = window.availableLanguages || ['en', 'tr'];

    // 3. Determine browser preference
    var browserLang = (navigator.language || navigator.userLanguage || 'en').split('-')[0].toLowerCase();

    // 4. Determine country mapping
    var country = (window.Shopify && window.Shopify.country) || '';
    var countryToLang = {
      // Turkish
      'TR': 'tr',
      'CY': 'tr',
      // English
      'US': 'en',
      'GB': 'en',
      'CA': 'en',
      'AU': 'en',
      'NZ': 'en',
      'IE': 'en',
      'ZA': 'en',
      // French
      'FR': 'fr',
      'BE': 'fr',
      'CH': 'fr',
      'LU': 'fr',
      'MC': 'fr',
      // Spanish
      'ES': 'es',
      'MX': 'es',
      'AR': 'es',
      'CO': 'es',
      'PE': 'es',
      'VE': 'es',
      'CL': 'es',
      'EC': 'es',
      'GT': 'es',
      'CU': 'es',
      // German
      'DE': 'de',
      'AT': 'de',
      'LI': 'de',
      // Italian
      'IT': 'it',
      'SM': 'it',
      // Portuguese
      'PT': 'pt',
      'BR': 'pt',
      'AO': 'pt',
      'MZ': 'pt',
      // Russian
      'RU': 'ru',
      'BY': 'ru',
      'KZ': 'ru',
      'KG': 'ru',
      // Arabic
      'SA': 'ar',
      'AE': 'ar',
      'EG': 'ar',
      'DZ': 'ar',
      'MA': 'ar',
      'IQ': 'ar',
      'JO': 'ar',
      'KW': 'ar',
      'QA': 'ar',
      'OM': 'ar',
      'LB': 'ar',
      // Japanese
      'JP': 'ja',
      // Korean
      'KR': 'ko',
      // Chinese
      'CN': 'zh',
      'TW': 'zh',
      'HK': 'zh',
      'SG': 'zh',
      // Dutch
      'NL': 'nl',
      // Polish
      'PL': 'pl',
      // Swedish
      'SE': 'sv',
      // Norwegian
      'NO': 'no',
      // Danish
      'DK': 'da',
      // Finnish
      'FI': 'fi',
      // Indonesian
      'ID': 'id',
      // Vietnamese
      'VN': 'vi'
    };
    var countryLang = countryToLang[country] || '';

    // 5. Select target language
    var targetLocale = currentLocale;
    if (availableLangs.indexOf(browserLang) !== -1) {
      targetLocale = browserLang;
    } else if (countryLang && availableLangs.indexOf(countryLang) !== -1) {
      targetLocale = countryLang;
    }

    // 6. Switch language if it is different
    if (targetLocale !== currentLocale) {
      console.log('Auto-switching locale from ' + currentLocale + ' to ' + targetLocale + ' based on user context.');
      var form = document.querySelector('localization-form form[id*="LanguageForm"]');
      var input = form ? form.querySelector('input[name="locale_code"]') : null;
      if (form && input) {
        var returnToInput = form.querySelector('input[name="return_to"]');
        if (returnToInput) {
          returnToInput.value = window.location.pathname + window.location.search;
        }
        input.value = targetLocale;
        form.submit();
      } else {
        redirectToLanguage(targetLocale);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoDetectLanguage);
  else autoDetectLanguage();
})();
